import React from 'react'

import styled from 'styled-components'

import Navbar from '../defaultComponents/Navbar'
import AssetReturnsInternal from './AssetReturnsInternal'
import AssetReturnsStock from './AssetReturnsStock'
import InventoryIcon from '@mui/icons-material/Inventory';
import HomeRepairServiceIcon from '@mui/icons-material/HomeRepairService';

import BuildIcon from '@mui/icons-material/Build';
const ViewToggleWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`

const ViewToggleBox = styled.div`
  width: 90vw;
  padding-left: 2vw;
  padding-right: 2vw;

  display: flex;
  justify-content: flex-end;
`

const ViewToggleButton = styled.button`
  width: 120px;

  border: 2px solid tomato;
  border-radius: 3px;
  background: white;
  font-weight: bold;
  color: tomato;

  margin-top: 1vh;

  background: tomato;
  color: white;

  &:hover{
    background: darkred;
    border: 2px solid darkred;
  }

  padding: 5px 0vw 5px 0vw;

  display: flex;
  align-items: center;
  justify-content: center;

  gap: 10px;
`

export default function AssetReturnsParent() {

  const [view, setView] = React.useState("Usage")

  const handleViewToggle = () => {
    if (view === "Usage") {
      setView("Stock")
    }
    else if (view === "Stock") {
      setView("Usage")
    }
  }

  return (
    <>
      <Navbar pageType="Dashboard" />
      <ViewToggleWrapper>
        <ViewToggleBox>
          <ViewToggleButton onClick={() => (handleViewToggle())}>
            
             
            
            {view === "Usage" && <><InventoryIcon sx={{fontSize:"20px"}}/> Stock</>}
            {view === "Stock" && <><HomeRepairServiceIcon sx={{fontSize:"20px"}}/> Usage</>  }
          </ViewToggleButton>
        </ViewToggleBox>

      </ViewToggleWrapper>
      {view === "Usage" &&
        <AssetReturnsInternal />
      }

      {view === "Stock" &&
        <AssetReturnsStock />
      }
    </>
  )
}
